export default class ProductPopup {
    constructor() {
        this.productPage = document.querySelector('.single-product');
        if (!this.productPage)
            return;
        this.popupToggles = this.productPage.querySelectorAll('.image-wrap[data-product-video]');
        if (!this.popupToggles)
            return;
        this.popup = document.querySelector('[data-product-popup]');
        this.popupClose = this.popup.querySelector('.close-popup');
        this.videoContainers = this.popup.querySelectorAll('.video-container');
        this.addEventListeners();
    }
    addEventListeners() {
        this.popupToggles.forEach(toggle => {
            toggle.addEventListener('click', this.togglePopup.bind(this));
        });
        this.popupClose.addEventListener('click', this.togglePopup.bind(this));
    }
    togglePopup(event) {
        event.preventDefault();
        const currentToggle = event.currentTarget;
        if (currentToggle.classList.contains('close-popup')) {
            this.popup.classList.toggle('active');
            return;
        }
        // get video id from data-product-video
        const videoId = currentToggle.getAttribute('data-product-video');
        // find video container with such id
        this.videoContainers.forEach(container => {
            if (container.getAttribute('data-product-video') === videoId) {
                container.classList.add('active');
            }
            else {
                container.classList.remove('active');
            }
        });
        this.popup.classList.toggle('active');
    }
}
